import React from 'react';
import { useTable } from 'react-table';

// 숫자를 3자리마다 콤마로 구분하는 유틸리티 함수
const formatNumber = number => {
  if (typeof number === 'number') {
    return number.toLocaleString(); // 숫자를 3자리마다 콤마로 구분된 문자열로 변환
  }
  return number;
};

// 시작과 종료 시간을 기반으로 가동시간을 계산하는 함수
const calculateRunTime = (startHour, startMinute, endHour, endMinute) => {
  const startTotalMinutes = parseInt(startHour) * 60 + parseInt(startMinute);
  const endTotalMinutes = parseInt(endHour) * 60 + parseInt(endMinute);

  const endTotalMinutesAdjusted = endTotalMinutes < startTotalMinutes ? endTotalMinutes + 24 * 60 : endTotalMinutes;

  return endTotalMinutesAdjusted - startTotalMinutes;
};

const StopOperationTable = ({ columns, data }) => {
  const { getTableProps, getTableBodyProps, rows, prepareRow } = useTable({ columns, data });

  return (
    <table {...getTableProps()} className='w-full table-fixed'>
      <thead>
        <tr className='bg-navy text-white'>
          {/* 시작 */}
          <th colSpan={2} className='b2-t b2-b b2-l p-2 text-center w-[90px] sm:w-[135px] md:w-[180px]'>
            시작
          </th>
          <th colSpan={2} className='b2-t b2-b b2-l p-2 text-center w-[90px] sm:w-[135px] md:w-[180px]'>
            종료
          </th>
          {/* 가동시간 */}
          <th rowSpan={2} className='b2-t b2-b b2-l p-2 text-center w-[60px] sm:w-[90px] md:w-[120px]'>
            중지시간
          </th>
          {/* 지종 */}
          <th rowSpan={2} className='b2-t b2-b b2-l p-2 text-center w-[60px] sm:w-[90px] md:w-[120px]'>
            지종
          </th>
          {/* 평량 */}
          <th rowSpan={2} className='b2-t b2-b b2-l p-2 text-center w-[60px] sm:w-[90px] md:w-[120px]'>
            기준평량
          </th>
          {/* 평량 */}
          <th rowSpan={2} className='b2-t b2-b b2-l p-2 text-center w-[60px] sm:w-[90px] md:w-[120px]'>
            중지구분
          </th>
          {/* 평량 */}
          <th rowSpan={2} className='b2-t b2-b b2-l p-2 text-center w-[80px] sm:w-[120px] md:w-[160px]'>
            중지사유
          </th>
          {/* 평량 */}
          <th rowSpan={2} className='b2-t b2-b b2-l p-2 text-center w-[120px] sm:w-[180px] md:w-[240px]'>
            장소
          </th>
          {/* 평량 */}
          <th rowSpan={2} className='b2-t b2-b b2-l p-2 text-center w-[60px] sm:w-[90px] md:w-[120px]'>
            내용
          </th>
          {/* 평량 */}
          <th rowSpan={2} className='b2-t b2-b b2-l p-2 text-center w-[60px] sm:w-[90px] md:w-[120px]'>
            작업반
          </th>
        </tr>
        <tr className='bg-navy text-white'>
          {/* 시작: 시/분 */}
          <th className='b2-t b2-b b2-l p-2 text-center w-[45px] sm:w-[67.5px] md:w-[90px] b2-r'>시</th>
          <th className='b2-t b2-b b2-r p-2 text-center w-[45px] sm:w-[67.5px] md:w-[90px]'>분</th>
          {/* 종료: 시/분 */}
          <th className='b2-t b2-b p-2 text-center w-[45px] sm:w-[67.5px] md:w-[90px] b2-r'>시</th>
          <th className='b2-t b2-b p-2 text-center w-[45px] sm:w-[67.5px] md:w-[90px]'>분</th>
        </tr>
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map(row => {
          prepareRow(row);
          const { startHour, startMinute, endHour, endMinute } = row.original;
          const runTime = calculateRunTime(startHour, startMinute, endHour, endMinute);

          return (
            <tr {...row.getRowProps()} className='border-b'>
              {row.cells.map(cell => (
                <td
                  key={cell.column.id}
                  {...cell.getCellProps()}
                  className={`b2-t b2-b b2-l p-2 text-ellipsis overflow-hidden whitespace-nowrap ${
                    // 중앙 정렬이 필요한 열
                    [
                      'startHour',
                      'startMinute',
                      'endHour',
                      'endMinute',
                      'stopType',
                      'paperType',
                      'standardWeight',
                      'place',
                      'stopReason',
                      'context',
                      'workingGroup',
                    ].includes(cell.column.id)
                      ? 'text-center'
                      : ['stopspeed'].includes(cell.column.id)
                      ? 'text-right'
                      : 'text-left'
                  }`}
                >
                  {/* 데이터 포맷팅 */}
                  {cell.column.id === 'stopspeed'
                    ? formatNumber(runTime) // 계산된 가동시간 표시
                    : ['theoreticalProduction', 'spoolWidth'].includes(cell.column.id)
                    ? formatNumber(cell.value) // 콤마로 포맷된 값
                    : cell.render('Cell')}
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default StopOperationTable;
